module.exports = __webpack_public_path__ + "static/media/E_WHITOUT_B_644C.c68141d9.jpg";